import {IStorage} from "@kta20-core/interfaces/i-storage";

class Storage implements IStorage{
    async clear(): Promise<void> {
        window.localStorage.clear();
    }

    async getItem(key: string,asJSON:boolean=false): Promise<string | object | null> {
        const value = asJSON ? JSON.parse(window.localStorage.getItem(key)) : window.localStorage.getItem(key);
        return Promise.resolve(value);
    }

    async getLength(): Promise<number> {
        return Promise.resolve(window.localStorage.length);
    }

    async key(index: number): Promise<string | null> {
        return Promise.resolve(window.localStorage.key(index));
    }

    async removeItem(key: string): Promise<void> {
        window.localStorage.removeItem(key);
    }

    async setItem(key: string, value: string | object): Promise<void> {
        value = typeof value==='string' ? value : JSON.stringify(value);

        window.localStorage.setItem(key,value);
    }

    async match(searchInKey: string): Promise<string[]> {
        const match:string[]=[];
        for (let i=0;i<window.localStorage.length;i++){
            const key = window.localStorage.key(i);
            if(key.indexOf(searchInKey)!=-1) match.push(key);
        }
        return match;
    }
}

export {Storage}